export function getServicesKey(services: string[]) {
  return [...services].sort().join('-');
}
